import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sidebar-top px-3"
}
const _hoisted_2 = { class: "widget s20 text-black p-4 rounded-40 shadow-200 mb-6 px-7 pt-7 pb-6" }
const _hoisted_3 = { class: "secondary-font text-primary-color" }
const _hoisted_4 = { class: "app-section" }

import { ref, onMounted } from 'vue'
import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'
import walletService from '@/services/walletService'
import { formatAmount } from '@/utils/formatters'


export default /*@__PURE__*/_defineComponent({
  __name: 'WalletLayout',
  setup(__props) {

const balance = ref<number | null>(null)

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/wallet',
    icon: '/public/icons/icon-dashboard.svg',
    label: 'Dashboard',
    exact: true,
    initialSidebarOpen: false
  },
  {
    to: '/front/wallet/utilisation',
    icon: '/public/icons/icon-utilisation.svg',
    label: 'Utilisation',
    initialSidebarOpen: true
  }
]

onMounted(async () => {
  try {
    const res = await walletService.getBalance()
    if (res.data) balance.value = res.data.balance || 0
  } catch (e) {
    // silencieux
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SectionSidebar, { "menu-items": menuItems }, {
      widget: _withCtx(() => [
        (balance.value !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex align-items-center gap-4 mb-3" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-wallet.svg",
                    class: "size-base icon-neutral",
                    alt: ""
                  }),
                  _createElementVNode("h4", { class: "secondary-font" }, "Wallet")
                ], -1)),
                _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(formatAmount)(balance.value)) + " F ", 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "page-space-25" }, null, -1)),
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})